export default "__VITE_ASSET__e3de1d64__"